<template>
  <div class="devicesList">
    <div class="devicesList__header">
      <div class="devicesList__header__left">
        <div class="devicesList__header__left__status">
          <adx-dropdown-search :list="locations" labelButton="Location" :selected-value="selectedLocationValue"/>
        </div>
        <div class="devicesList__header__left__status">
          <adx-dropdown-list :labelButton="selectedStatusLabel?selectedStatusLabel:`Status`" :valueDisplay="selectedStatusValue" :list="statusList" />
        </div>
        <div class="devicesList__header__left__status">
          <adx-dropdown-list :labelButton="selectedConditionLabel?selectedConditionLabel:`Condition`" :valueDisplay="selectedConditionValue" :list="conditionList" />
        </div>
        <div class="devicesList__header__left__status">
          <adx-dropdown-list :labelButton="`Photo`" :valueDisplay="selectedPhotoValue" :list="photoList" />
        </div>
        <div v-if="filtered" class="reset">
          <button class="btn-regular primary" @click="resetFilter">Reset</button>
        </div>
      </div>
      <div class="devicesList__header__right">
        <p>Sort by :</p>
        <div>
          <adx-dropdown-sort  :labelButton="`All Filter`"
           :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
        </div>
      </div>
    </div>
    <div class="devicesList__search">
      <i class="adx-ic_search"></i>
      <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
    </div>
    <!-- devicesList -->
    <div class="devicesList__content">
      <div>
        <table>
          <thead class="none">
            <tr>
              <td class="header subhead">ID</td>
              <td class="header subhead">Devices</td>
              <td class="header subhead">Price/slot</td>
              <td class="header subhead">Orientation</td>
              <td class="header subhead">Active</td>
              <td class="header subhead">Photo</td>
              <td class="header subhead">Public</td>
            </tr>
          </thead>
          <tbody v-if="!isLoading && !isEmpty">
            <tr v-for="(item, index) in items" :key="index" class="content">
              <td class="ID subhead">
               <span :class="['strong']" @click.stop="goToEdit({item})"> {{item.pub_id}}</span>
              </td>
              <td class="devices subhead" > 
                <div>{{item.location_name}}, {{item.placement}}</div>
                <div class="action">
                  <span @click.stop="goToEdit({item})">Edit</span>
                  <span class="firstbtn"  @click.stop="duplicateDevices({item})">Duplicate</span>
                </div>
              </td>
              <td class="right priceslot subhead"> {{item.price | formatMoney}} </td>
              <td class="position orientation subhead">{{ item.orientation }}</td>
              <td class="position active subhead">
                <div v-if= item.is_active>V</div><div v-else>-</div></td>
              <td class="position photo subhead">
                <div v-if= item.primary_photo>V</div><div v-else>-</div></td>
              <td class="position public subhead">
                <div v-if= item.is_public>V</div><div v-else>-</div></td>
            </tr>
          </tbody>
        </table>
        <!-- Pagination -->
        <div class="pagination" v-if="!isLoading && !isEmpty"><adx-pagination :selectedPage="selectedPage" 
        :maxPage="maxPage" /></div>
        <!-- Loading State -->
        <div class="loadingState"><adx-loading v-if="isLoading" slot="loading" /></div>
        <!-- Empty State -->
        <div class="emptyState"><adx-empty-selection v-if="isEmpty && !isLoading" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/SideBar/Desktop'
import DropdownSort from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import Modal from '@/components/Modal'
import types from '@/lib/types'
import EmptySelection from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'
import LoadingSpin from '@/components/Loading/Secondary'
import Pagination from '@/components/Pagination'
import DropdownSearch from '@/components/Dropdown/SearchDropdown'

// Api
import api from '@/api'
import { apiV2 } from '@/api/urls'
import * as validationLib from '@/lib/validation/'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex';
const {
  helpers,
  validate
} = validationLib

export default {
  name: 'adx-deviceList',
  components: {
    'adx-sidebar': SideBar,
    'adx-dropdown-list': ListDropdown,
    'adx-dropdown-sort': DropdownSort,
    'adx-modal': Modal,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
    'adx-loading-spin': LoadingSpin,
    'adx-pagination': Pagination,
    'adx-dropdown-search': DropdownSearch,
  },
  data() {
    return {
      selectAll: false,
      isOpen: false,
      sort: [
        {
          'id': 0,
          'label': 'Last Added',
          'value': 'last_added'
        },
        {
          'id': 1,
          'label': 'First Added',
          'value': 'first_added'
        },
        {
          'id': 2,
          'label': 'Name',
          'value': 'name'
        },
      ],
      selectedSortValue: 'last_added',
      searchBoxValue: '',
      selectedRow: null,
      isInit: true,
      isLoading: false,
      isLoadingDelete: false,
      isEmpty: false,
      details: [],
      selectedPage: 1,
      maxPage: 0,
      items: [],
      all_data: [],
      selectedStatusValue: null,
      selectedStatusLabel: null,
      selectedConditionValue: null,
      selectedConditionLabel: null,
      selectedPhotoValue: null,
      selectedPhotoLabel: null,
      locations: [],
      selectedLocationValue: null,
      filterList: [
        {
          id: 0,
          label: 'All Filter',
          value: 'allfilter'
        },
        {
          id: 1,
          label: 'Active',
          value: 'active'
        },
        {
          id: 2,
          label: 'Photo',
          value: 'photo'
        },
        {
          id: 3,
          label: 'Public',
          value: 'public'
        },
      ],
      statusList: [
        {
          id: 0,
          label: 'All',
          value: null
        },
        {
          id: 1,
          label: 'Public',
          value: "True"
        },
        {
          id: 2,
          label: 'Private',
          value: "False"
        },
      ],
      conditionList: [
        {
          id: 0,
          label: 'All',
          value: null
        },
        {
          id: 1,
          label: 'Active',
          value: "True"
        },
        {
          id: 2,
          label: 'Inactive',
          value: "False"
        },
      ],
      photoList: [
        {
          id: 0,
          label: 'All',
          value: null
        },
        {
          id: 1,
          label: 'Have Photo',
          value: "True"
        },
        {
          id: 2,
          label: 'Unset',
          value: "False"
        },
      ]
    }
  },
  computed: {
    filtered: function() {
      let filtered = false
      if (this.selectedPhotoLabel || this.selectedConditionLabel || this.selectedStatusLabel) {
        filtered = true
      }
      return filtered
    }
  },
  watch: {
    
  },
  beforeCreate() {

  },
  created() {
    // this.initialLoad()
  },
  beforeMount() {

  },
  mounted() {
    
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>